import { Component} from '@angular/core';
import { DbService } from '../_services/db.service';
import {FischeComponent} from './fische.component';
import {AuthenticationService} from '../_services';

@Component({
  selector: 'app-fisch-mobile',
  templateUrl: './fische.component.mobile.html',
  styleUrls: ['../home/home.component.mobile.css']
})
export class FischeMobileComponent extends FischeComponent{

  constructor(
    service: DbService,
    authenticationService: AuthenticationService) {
    super(service, authenticationService);
  }

}
